import {AssayResult} from 'results/assays/AssayRecordConstants';
import {AssayResultValidation} from 'results/validation/ValidationConstants';
import {BenchlingBlob} from 'schemas/tags/BlobConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

interface DataTablesValidationStatus {
  assayResultsById: {[id: string]: AssayResult};
  assayResultValidationsByResultId: {[resultId: string]: AssayResultValidation};
  errorsByRecordId: {[recordId: string]: {[fieldId: string]: string}};
}

export function fetchDataTablesValidationStatus(entryId: string): Promise<DataTablesValidationStatus> {
  return net.getJSONPromise('/1/api/workflows/data-tables/validation-status', {entryId});
}

export function createBlobs(
  s3Locations: Array<string>,
  {shouldGeneratePreviewFile}: {shouldGeneratePreviewFile: boolean}
): JQueryPromise<Array<BenchlingBlob>> {
  return TaskRunner.postJSON({
    url: '/1/api/results/blobs',
    data: {s3Locations, shouldGeneratePreviewFile},
  }).then(({blobs}) => blobs);
}
